import React from "react";
import "./TermsConditions.css";

export default function PrivacyPolicy() {
  return (
    <div className="policyPage">
      <div className="policyWrap">
        <h1 className="policyTitle">Privacy Policy</h1>
        <p className="policyLastUpdated">Last Updated: March 5, 2026</p>

        <div className="policyCard">
          <p className="policyIntro">
            Welcome to Ayrine. Your privacy is important to us. This Privacy Policy explains how Ayrine
            collects, uses, shares, and protects your personal information when you visit our website, make
            a purchase, or interact with us.
            <br /><br />
            Ayrine operates its online store using Shopify, which enables us to provide secure and seamless
            shopping services.
            <br /><br />
            By accessing or using our website and services ("Services"), you agree to the terms of this
            Privacy Policy.
          </p>

          {/* Section 1 */}
          <section className="policySection">
            <h2>1. Information We Collect</h2>
            <p>We may collect the following categories of personal information:</p>

            <h3>A. Information You Provide Directly</h3>
            <ul>
              <li>Full name</li>
              <li>Billing and shipping address</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Payment details</li>
              <li>Account login credentials</li>
              <li>Messages sent to our customer support</li>
            </ul>

            <h3>B. Information Collected Automatically</h3>
            <ul>
              <li>IP address</li>
              <li>Browser type and device information</li>
              <li>Pages visited and browsing behavior</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h3>C. Transaction Information</h3>
            <ul>
              <li>Products viewed, added to cart, or purchased</li>
              <li>Order history</li>
              <li>Returns, exchanges, and cancellations</li>
            </ul>
          </section>

          {/* Section 2 */}
          <section className="policySection">
            <h2>2. How We Use Your Information</h2>
            <p>We use your personal information to:</p>
            <ul>
              <li>Process and fulfill orders</li>
              <li>Provide shipping and delivery services</li>
              <li>Manage your account</li>
              <li>Send order confirmations and updates</li>
              <li>Provide customer support</li>
              <li>Improve our website and shopping experience</li>
              <li>Prevent fraud and enhance security</li>
              <li>Send promotional emails and marketing communications (you may opt out anytime)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section className="policySection">
            <h2>3. Sharing of Information</h2>
            <p>We do not sell your personal information.</p>
            <p>We may share your information with:</p>
            <ul>
              <li>Payment processing providers</li>
              <li>Shipping and logistics partners</li>
              <li>Technology and hosting partners (including Shopify)</li>
              <li>Marketing service providers</li>
              <li>Government authorities when required by law</li>
            </ul>
            <p>All third parties are required to handle your data securely and lawfully.</p>
          </section>

          {/* Section 4 */}
          <section className="policySection">
            <h2>4. Cookies &amp; Tracking Technologies</h2>
            <p>Our website uses cookies to:</p>
            <ul>
              <li>Remember your preferences</li>
              <li>Improve website functionality</li>
              <li>Analyze traffic and performance</li>
              <li>Deliver relevant advertisements</li>
            </ul>
            <p>
              You may disable cookies through your browser settings; however, this may affect certain
              website features.
            </p>
          </section>

          {/* Section 5 */}
          <section className="policySection">
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal
              information. However, no system is 100% secure, and we cannot guarantee absolute security
              of transmitted data.
            </p>
          </section>

          {/* Section 6 */}
          <section className="policySection">
            <h2>6. Data Retention</h2>
            <p>We retain personal information only as long as necessary to:</p>
            <ul>
              <li>Provide services</li>
              <li>Maintain transaction records</li>
              <li>Comply with legal requirements</li>
              <li>Resolve disputes</li>
            </ul>
          </section>

          {/* Section 7 */}
          <section className="policySection">
            <h2>7. Your Rights</h2>
            <p>
              As a resident of India and depending on applicable laws, you may have the right to:
            </p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
            <p>To exercise these rights, please contact us using the details below.</p>
          </section>

          {/* Section 8 */}
          <section className="policySection">
            <h2>8. Children's Privacy</h2>
            <p>
              Our Services are not intended for individuals under 18 years of age. We do not knowingly
              collect personal information from children.
            </p>
          </section>

          {/* Section 9 */}
          <section className="policySection">
            <h2>9. International Data Transfers</h2>
            <p>
              Your information may be processed outside India through our service providers. We ensure
              appropriate safeguards are in place to protect your data.
            </p>
          </section>

          {/* Section 10 */}
          <section className="policySection">
            <h2>10. Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page
              with an updated "Last Updated" date.
            </p>
          </section>

          {/* Section 11 */}
          <section className="policySection">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or wish to exercise your rights, please
              contact:
            </p>
            <p>
              <strong>Ayrine</strong><br />
              Tolichowki, Paramount Hills Colony Gate No 2<br />
              Opp Paramount Heights, Paramount Hills<br />
              Toli Chowki, Hyderabad<br />
              Telangana 500008, India
            </p>
            <p>📧 Email: <a href="mailto:info@ayrine.in">info@ayrine.in</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
